// @flow

import React, { Fragment } from 'react';

type Props = {
  type: string,
  color: string,
  size: string
}

const TYPE_LIST = [ 'VIDEO', 'PHOTO', 'CERTIFICATE' ];

const renderIcon = (type: string, color: string) => {
  switch (type) {
    case TYPE_LIST[0]:
      return (
        <Fragment>
          <path d="M8,40 L34,40 C35.1045694,40 36,40.8954306 36,42 C36,43.1045694 35.1045694,44 34,44 L8,44 C5.790861,44 4,42.209139 4,40 L4,14 C4,12.8954305 4.8954305,12 6,12 C7.1045695,12 8,12.8954305 8,14 L8,40 Z M16,4 L40,4 C42.209139,4 44,5.790861 44,8 L44,32 C44,34.209139 42.209139,36 40,36 L16,36 C13.790861,36 12,34.209139 12,32 L12,8 C12,5.790861 13.790861,4 16,4 Z M25.6,27.8000588 L34.9333334,20.8000588 C35.3751612,20.468688 35.4647042,19.8418867 35.1333334,19.4000589 C35.076479,19.3242532 35.009139,19.2569131 34.9333334,19.2000589 L25.6,12.2000589 C25.1581722,11.868688 24.5313708,11.9582311 24.2,12.4000589 C24.0701778,12.573155 24,12.7836886 24,13.0000589 L24,27.0000588 C24,27.5523436 24.4477152,28.0000588 25,28.0000588 C25.2163702,28.0000588 25.4269038,27.929881 25.6,27.8000588 Z" fill={color} fillRule="nonzero" />
          <polygon points="0 0 48 0 48 48 0 48" />
        </Fragment>
      );
    case TYPE_LIST[1]:
      return (
        <Fragment>
          <path d="M8,40 L34,40 C35.1045694,40 36,40.8954306 36,42 C36,43.1045694 35.1045694,44 34,44 L8,44 C5.790861,44 4,42.209139 4,40 L4,14 C4,12.8954305 4.8954305,12 6,12 C7.1045695,12 8,12.8954305 8,14 L8,40 Z M16,4 L40,4 C42.209139,4 44,5.790861 44,8 L44,32 C44,34.209139 42.209139,36 40,36 L16,36 C13.790861,36 12,34.209139 12,32 L12,8 C12,5.790861 13.790861,4 16,4 Z M38,30 L38,29.8578644 L24.8492424,16.7071068 C24.4587182,16.3165825 23.8255532,16.3165825 23.4350288,16.7071068 L18,22.1421356 L18,30 L38,30 Z M34,18 C36.209139,18 38,16.209139 38,14 C38,11.790861 36.209139,10 34,10 C31.790861,10 30,11.790861 30,14 C30,16.209139 31.790861,18 34,18 Z" fill={color} fillRule="nonzero" />
          <polygon points="0 0 48 0 48 48 0 48" />
        </Fragment>
      );
    case TYPE_LIST[2]:
      return (
        <Fragment>
          <path d="M40,34 L42,34 L42,10 L6,10 L6,34 L16,34 L16,38 L6,38 C3.8,38 2,36.4 2,34.4444444 L2,9.55555556 C2,7.6 3.8,6 6,6 L42,6 C44.2,6 46,7.6 46,9.55555556 L46,34.4444444 C46,36.4 44.2,38 42,38 L40,38 L40,34 Z M12,14 L36,14 C37.1045694,14 38,14.8954305 38,16 C38,17.1045695 37.1045694,18 36,18 L12,18 C10.8954305,18 10,17.1045695 10,16 C10,14.8954305 10.8954305,14 12,14 Z M12,22 L16,22 C17.1045695,22 18,22.8954306 18,24 C18,25.1045694 17.1045695,26 16,26 L12,26 C10.8954305,26 10,25.1045694 10,24 C10,22.8954306 10.8954305,22 12,22 Z M34.475,37.947 L37.392,43 L33.741,42.676 L32.196,46 L29.263,40.92 C28.913,40.967 28.559,41 28.196,41 C27.833,41 27.479,40.967 27.129,40.92 L24.196,46 L22.634,42.705 L19,43 L21.917,37.947 C20.842,36.585 20.196,34.869 20.196,33 C20.196,28.582 23.778,25 28.196,25 C32.614,25 36.196,28.582 36.196,33 C36.196,34.869 35.55,36.585 34.475,37.947 Z M28.196,37 C30.405,37 32.196,35.209 32.196,33 C32.196,30.791 30.405,29 28.196,29 C25.987,29 24.196,30.791 24.196,33 C24.196,35.209 25.987,37 28.196,37 Z" fill={color} fillRule="nonzero" />
          <polygon points="0 0 48 0 48 48 0 48" />
        </Fragment>
      );
    default:
      return null;
  }
};

const MediaIcon = ({ type, color, size }: Props) => {
  return (
    type
      ? <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 48 48">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          {renderIcon(type, color)}
        </g>
      </svg> : null
  );
};

export default MediaIcon;
